<template>
  <div class="ed-condition-formula">
    <div class="ed-condition-formula__toggle join w-full">
      <button
        type="button"
        class="btn btn-sm join-item flex-1 normal-case font-normal"
        :class="{ 'btn-active': valueType === 'fixed' }"
        @click="setValueType('fixed')"
      >
        {{ t('fixed_value') }}
      </button>
      <button
        type="button"
        class="btn btn-sm join-item flex-1 normal-case font-normal"
        :class="{ 'btn-active': valueType === 'formula' }"
        @click="setValueType('formula')"
      >
        {{ t('formula') }}
      </button>
    </div>

    <input
      v-if="valueType === 'fixed'"
      :value="fixedValue"
      type="number"
      step="any"
      class="input input-bordered input-sm w-full bg-white h-11 pl-4 text-base font-normal mt-3"
      :class="{ 'text-gray-300': !fixedValue }"
      :placeholder="t('type_value')"
      required
      @input="$emit('update:fixed-value', $event.target.value)"
    >

    <div
      v-else
      class="ed-condition-formula__builder mt-3"
    >
      <p class="ed-condition-formula__hint">
        {{ t('condition_formula_hint') }}
      </p>

      <div
        v-if="numberFields.length"
        class="ed-condition-formula__fields"
      >
        <button
          v-for="field in numberFields"
          :key="field.uuid"
          type="button"
          class="ed-condition-formula__field-chip"
          @click.prevent="insertText(`{{${field.name || buildDefaultName(field)}}}`)"
        >
          <IconMathFunction
            v-if="field.preferences?.formula"
            width="14"
            height="14"
            stroke-width="1.5"
          />
          <IconCodePlus
            v-else
            width="15"
            height="15"
            stroke-width="1.5"
          />
          <span>{{ field.name || buildDefaultName(field) }}</span>
        </button>
      </div>

      <div class="ed-condition-formula__operators">
        <button
          v-for="operator in operators"
          :key="operator.insert"
          type="button"
          class="ed-condition-formula__operator"
          @click.prevent="insertText(operator.insert)"
        >
          {{ operator.label }}
        </button>
      </div>

      <textarea
        ref="textarea"
        :value="formulaValue"
        class="ed-condition-formula__input"
        :placeholder="t('condition_formula_placeholder')"
        rows="2"
        required
        @input="onFormulaInput"
      />
    </div>
  </div>
</template>

<script>
import { IconCodePlus, IconMathFunction } from '@tabler/icons-vue'

export default {
  name: 'ConditionFormulaBuilder',
  components: {
    IconCodePlus,
    IconMathFunction
  },
  inject: ['t'],
  props: {
    valueType: {
      type: String,
      default: 'fixed'
    },
    fixedValue: {
      type: String,
      default: ''
    },
    formulaValue: {
      type: String,
      default: ''
    },
    numberFields: {
      type: Array,
      default: () => []
    },
    buildDefaultName: {
      type: Function,
      required: true
    }
  },
  emits: ['update:value-type', 'update:fixed-value', 'update:formula-value'],
  data () {
    return {
      operators: [
        { label: '+', insert: ' + ' },
        { label: '−', insert: ' - ' },
        { label: '×', insert: ' * ' },
        { label: '÷', insert: ' / ' },
        { label: '(', insert: '(' },
        { label: ')', insert: ')' }
      ]
    }
  },
  watch: {
    formulaValue () {
      this.$nextTick(() => this.resizeTextarea())
    },
    valueType (type) {
      if (type === 'formula') {
        this.$nextTick(() => this.resizeTextarea())
      }
    }
  },
  mounted () {
    if (this.valueType === 'formula') {
      this.$nextTick(() => this.resizeTextarea())
    }
  },
  methods: {
    setValueType (type) {
      this.$emit('update:value-type', type)
    },
    onFormulaInput (event) {
      this.$emit('update:formula-value', event.target.value)
      this.resizeTextarea()
    },
    insertText (textToInsert) {
      const textarea = this.$refs.textarea

      if (!textarea) return

      const cursorPos = textarea.selectionEnd
      const nextValue = textarea.value.substring(0, cursorPos) + textToInsert + textarea.value.substring(cursorPos)

      this.$emit('update:formula-value', nextValue)

      this.$nextTick(() => {
        textarea.focus()
        textarea.setSelectionRange(cursorPos + textToInsert.length, cursorPos + textToInsert.length)
        this.resizeTextarea()
      })
    },
    resizeTextarea () {
      const textarea = this.$refs.textarea

      if (!textarea) return

      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }
}
</script>
